import { isAfter, isBefore } from "date-fns";

export interface PublishingDates {
  publishedAt: string | null;
  publishedEnd: string | null;
  releasePublishedAt: string | null;
  releasePublishedEnd: string | null;
}

export const resolvePublishDate = ({
  publishedAt,
  releasePublishedAt,
}: PublishingDates): Date | null => {
  const productDate = publishedAt ? new Date(publishedAt) : null;
  if (productDate) return productDate;
  const releaseDate = releasePublishedAt ? new Date(releasePublishedAt) : null;
  if (releaseDate) return releaseDate;
  return null;
};

export const isScheduled = (dates: PublishingDates): boolean => {
  const publishedDate = resolvePublishDate(dates);
  if (!publishedDate) return false;
  return isBefore(new Date(), publishedDate);
};

export const isLive = (dates: PublishingDates): boolean => {
  const publishedDate = resolvePublishDate(dates);
  if (!publishedDate) return true;
  const now = new Date();
  const { publishedEnd, releasePublishedEnd } = dates;
  if (publishedEnd) {
    const endDate = new Date(publishedEnd);
    if (isAfter(now, publishedDate) && isBefore(now, endDate)) {
      return true;
    }
  }
  if (releasePublishedEnd) {
    const endDate = new Date(releasePublishedEnd);
    if (isAfter(now, publishedDate) && isBefore(now, endDate)) {
      return true;
    }
  }

  return false;
};

/**
 * Checks if a release or product is live based on its published dates.
 */
export const isLiveSimple = (
  publishedAt: string | null,
  publishedEnd: string | null,
): boolean => {
  const publishedDate = publishedAt ? new Date(publishedAt) : null;
  const publishedEndDate = publishedEnd ? new Date(publishedEnd) : null;

  if (!publishedDate) {
    return false;
  }

  const now = new Date();

  return (
    isAfter(now, publishedDate) &&
    (!publishedEndDate || isAfter(publishedEndDate, now))
  );
};

/**
 * Checks if a release or product is scheduled for the future based on its published dates.
 */
export const isScheduledSimple = (
  publishedAt: string | null,
  publishedEnd: string | null,
): boolean => {
  const publishedDate = publishedAt ? new Date(publishedAt) : null;
  const publishedEndDate = publishedEnd ? new Date(publishedEnd) : null;

  if (!publishedDate) {
    return false;
  }

  const now = new Date();

  return (
    isAfter(publishedDate, now) &&
    (!publishedEndDate || isAfter(publishedEndDate, now))
  );
};
